import { sva } from "@agapi/ui/panda/css";

export const languagePickerStyles = sva({
  slots: [
    "content",
    "positioner",
    "button",
    "container",
    "sectionContainer",
    "sectionTitle",
    "buttonContainer",
  ],
  base: {
    content: {
      bg: "surface.default.background",
      borderRadius: "3",
      boxShadow: "2px 4px 4px rgba(0,0,0,0.18)",
      p: "5",
      zIndex: "998",
      maxWidth: "475px",
      minWidth: "300px",
      overflow: "hidden!",
    },
    button: {
      justifyContent: "start",
      fontSize: "12",
    },
    container: {
      gap: "4",
    },
    sectionContainer: {
      gap: "3",
    },
    buttonContainer: {
      gap: "2",
      display: "flex",
      flexDir: "row",
      flexWrap: "wrap",
      py: "3"
    },
  },
});
